/**
 * api接口统一管理
 */
import { get, post, deleteFn, put, deleteBody, axios_,postParams } from './http'
const baseURL = axios_.defaults.baseURL







//添加
export const contactAdd = params => get('/temp/addContact', params)

//商品相关

// 获取用户优惠券
export const getUserCardList = params => get('/yuedong/xty/user/card/list', params)

// 获取订单模式
export const getOrderMode = params => get('/yuedong/config/getOrderMode', params)


export const getStarbucksStore = params => get('/yuedong/xty/star/getStarbucksStore', params)
//分组查询
export const goodsGroupSelect = params => get('/yuedong/hcStar/getStarGoodsType', params)
//商品列表查询
// export const goodsListSelect = params => get('/yuedong/hcStar/getStarGoodsList', params)
export const goodsListSelect = params => get('/yuedong/xty/star/getStarbucksProduct', params)

//商品详情接口查询
export const goodsSpecSelect = params => get('/yuedong/hcStar/getStarGoodsInfo', params,)

//购物车相关
//新增
export const addShopCar = params => post('/yuedong/shopping/add', params)
//删除-修改
export const editShopCar = params => put('/yuedong/shopping/edit',params)
//清空
export const clearShopCar = params => deleteFn('/yuedong/shopping/clear', params)
//查询
export const getShopCar = params => get('/yuedong/shopping/selectList', params)


//  优惠券

export const getCouponList = (status) => post(`/yuedong/coupon/getCouponList?page=1&limit=9999&status=${status?status:''}`)

export const addCoupon = (code) => post(`/yuedong/coupon/addCoupon?ticketCode=${code}`)


//用户相关
//账号进入
export const loginForAccount = (ticketAccountNo,platformCode) => post(`/yuedong/yuedongAccount/forTicketLink?ticketAccountNo=${ticketAccountNo}&platformCode=${platformCode}`)
//微信公众号进入
export const loginForWechatCode = (code) => post(`/yuedong/yuedongAccount/forWeixinOfficial?code=${code}`)
//微信小程序进入
export const loginForWechatApp = (openId) => post(`/yuedong/yuedongAccount/forWeixinApp?openId=${openId}`)
//发送短信验证码
export const smsSend = params => get('/yuedong/sms/send', params)
//登陆
export const mobileLogin = params => post('/yuedong/yuedongAccount/mobileLogin', params)
// 免密登录
export const loginFree = params=>post('/yuedong/yuedongAccount/noSecretsLogin',params)


export const getCouponInfo = params => get(`/yuedong/yuedongAccount/getCouponInfo`,params)
//解除绑定
export const relieveBound = params => post('/yuedong/yuedongAccount/relieveBound', params)
//绑定手机
export const bound = params => post('/yuedong/yuedongAccount/bound', params)
//通过Token查询用户信息
export const getYuedongAccount = params => get('/yuedong/yuedongAccount/getYuedongAccount')
//合并
export const mergeAccount = params => post('/yuedong/yuedongAccount/merge', params)
//合并前的查询
export const getMergeInfo = params => get('/yuedong/yuedongAccount/getMobileByAccountNo', params)
// /yuedong/yuedongAccount/getOpenId?code=
export const getOpenId = params => get('/yuedong/yuedongAccount/getOpenId', params)
//订单
//通过ID查询订单
export const getOrderById = params => get('/yuedong/xty/starOrder/queryOrderInfoById', params)
//新增订单
export const addOrder = params => post('/yuedong/xty/starOrder/add', params)
//查看历史订单
export const getHistoryOrder = params => get('/yuedong/xty/starOrder/list', params)
//查询订单支付状态
export const getOrderStatus = params => get('/yuedong/pay/selectWeiChatPayOrder', params)
// 查询支付宝支付结果
export const getAlliPayStatus = params => post('/yuedong/hf/adaQueryOrderStatus',params)
// 获取平台支付方式
export const getPlatformPayWay = params => get('/yuedong/platform/get',params)
// 判断余额是否够支付订单的价格
export const isPayedByBalance = params => get('/yuedong/xty/starOrder/checkBalance',params)
// 存入页面URL参数,用于 IOS 系统从商家小票页面跳回用
export const saveUnit = params => post('/yuedong/hf/savePayInfo',params)
// 测试能否获取到 存入的URL参数
// export const testGet = params=>post('/yuedong/hf/getPayInfo',params)

/* 支付方式 */
// 余额支付
export const getBalancePay = params => post('/yuedong/pay/balancePay', params)
// 官方微信支付
export const getWeixinPay = params => post('/yuedong/pay/weixinPay', params)
// 第三方微信支付--汇付
export const otherGetWxPay = params => post('/yuedong/hf/adaWxPub',params)
// 第三方支付宝支付--汇付
export const getAliPay = params => post('/yuedong/hf/adaAliApp',params)

//调用后端接口获取accessToken，jwtToken
export const getAuthToken = params => get('/yuedong/yuedongAccount/getAuthToken', params)
export const verifyPhoneWithToken = params => get('/yuedong/yuedongAccount/verifyPhoneWithToken', params)


